import channel from '@/components/channel'
let routes = [{
    path: '/channel',
    name: '频道',
    component: channel,
    children:[
      {
        path: '/setting',
        name: '展示设置',
        component: () => import('../components/channel_info/setting.vue')
      },
      {
        path: '',
        name: '频道详情',
        component: () => import('../components/channel_info/default.vue')
      },
      {
        path: '/gold-order',
        name: '频道详情',
        component: () => import('../components/channel_info/gold.vue')
      },
      {
        path: '/gold-repo',
        name: '频道详情',
        component: () => import('../components/channel_info/gold.vue')
      },
      {
        path: '/gold-my',
        name: '频道详情',
        component: () => import('../components/channel_info/gold.vue')
      },
      {
        path: '/c-bandu-my',
        name: '频道详情',
        component: () => import('../components/channel_info/common.vue')
      },
      {
        path: '/c-bandu',
        name: '频道详情',
        meta:{
            modules:['banner','process'],type:'3'
        },
        component: () => import('../components/channel_info/common.vue')
      },
      {
        path: '/c-library',
        name: '频道详情',
        meta:{
            modules:['banner','setting','notify'],type:'3'
        },
        component: () => import('../components/channel_info/common.vue')
      },
      {
        path: '/read-my',
        name: '付费我的频道',
        component: () => import('../components/channel_info/common.vue')
      },
      {
        path: '/read-zixun',
        name: '付费阅读频道',
        component: () => import('../components/channel_info/common.vue')
      },
      {
        path: '/read-guping',
        name: '股评频道',
        component: () => import('../components/channel_info/common.vue')
      },
      {
        path: '/read-xuetang',
        name: '学堂频道',
        component: () => import('../components/channel_info/common.vue')
      },
      {
        path: '/read-caopan',
        name: '操盘频道',
        component: () => import('../components/channel_info/common.vue')
      },
      {
        path: '/kf-publish',
        name: '康护公共频道',
        meta:{
            modules:['banners','setting','notify'],type:'6'
        },
        component: () => import('../components/channel_info/common.vue')
      },
      {
        path: '/kf-ziying',
        name: '康护自营频道',
        meta:{
            modules:['banners','setting','pmt','advantage','recommends'],type:'6'
        },
        component: () => import('../components/channel_info/common.vue')
      },
      {
        path: '/kf-my',
        name: '康护我的频道',
        meta:{
            type:'6'
        },
        component: () => import('../components/channel_info/common.vue')
      }
    ]
  }];

export default routes;


// WEBPACK FOOTER //
// ./src/router/channel.js